module.exports = __webpack_public_path__ + "media/assets/illustrations/resume-rev-logo-b3e77929dd32993b25a36b0d0642184d.svg";